import React from 'react';

import { useSnackBarMessage } from '@wp-react/notifications';

export default function SnackbarManager() {
  const snackbarMessage = useSnackBarMessage();
  return <>{snackbarMessage}</>;
}
